import Popover from 'app/components/Core/LineItem/Scheduler/Popover'
import KTag from 'app/components/UI-Elements/DataDisplay/KTag'
import { Ref } from 'react'
import * as React from 'react'
import { ReactCalendarItemRendererProps, TimelineItemBase } from 'react-calendar-timeline'

import { ISchedulerLineItem } from './Scheduler'

const lineItemStatusColor: { [key in ILineItemStatus]: string } = {
  canceled: 'red',
  done: 'gray',
  pending: 'blue',
  running: 'green'
}

interface Props
  extends ReactCalendarItemRendererProps<TimelineItemBase<number> & ISchedulerLineItem> {
  onClick: (item: ISchedulerLineItem) => void
}

const SchedulerItem = React.forwardRef(
  ({ item, getItemProps, getResizeProps, onClick }: Props, ref: Ref<React.ReactNode>) => {
    const props = getItemProps(item)
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { background, color, border, ...otherStyles } = props.style
    const { project, rentalCode, status } = item as ISchedulerLineItem

    return (
      <KTag
        ref={ref}
        {...props}
        {...getResizeProps()}
        className={`${props.className} overflow-hidden`}
        style={otherStyles}
        text={
          <Popover
            member={item}
            props={{ children: <span className="p-1">{project?.name || rentalCode}</span> }}
          />
        }
        color={lineItemStatusColor[status]}
        onClick={() => onClick(item)}
      />
    )
  }
)
SchedulerItem.displayName = 'SchedulerItem'

export default SchedulerItem
